var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 29.3332C6.88889 29.3332 5.94444 28.9443 5.16667 28.1665C4.38889 27.3887 4 26.4443 4 25.3332V21.3332H8V2.6665H28V25.3332C28 26.4443 27.6111 27.3887 26.8333 28.1665C26.0556 28.9443 25.1111 29.3332 24 29.3332H8ZM24 26.6665C24.3778 26.6665 24.6944 26.5387 24.95 26.2832C25.2056 26.0276 25.3333 25.7109 25.3333 25.3332V5.33317H10.6667V21.3332H22.6667V25.3332C22.6667 25.7109 22.7944 26.0276 23.05 26.2832C23.3056 26.5387 23.6222 26.6665 24 26.6665ZM12 11.9998V9.33317H24V11.9998H12ZM12 15.9998V13.3332H24V15.9998H12ZM8 26.6665H20V23.9998H6.66667V25.3332C6.66667 25.7109 6.79444 26.0276 7.05 26.2832C7.30556 26.5387 7.62222 26.6665 8 26.6665ZM8 26.6665H6.66667H20H8Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.1c732a5511c60d05e5a8e191f9056a22.svg";
export { ForwardRef as ReactComponent };